import { Component } from 'react';
import { Checkbox, Text } from '@chakra-ui/react';

interface IProps {
  id: string;
  blurb?: string;
  isTicked: boolean;
  onChange: (key: string, value: boolean) => void;
}

interface State {
  isTicked: boolean;
}

class CheckBoxQuestion extends Component<IProps, State> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isTicked: props.isTicked
    };
  }

  componentWillReceiveProps(props: IProps) {
    this.setState({
      isTicked: this.state.isTicked !== props.isTicked ? props.isTicked : this.state.isTicked
    });
  }

  onChange = () => {
    this.setState({ isTicked: !this.state.isTicked });
    this.props.onChange(this.props.id, !this.state.isTicked);
  };

  render() {
    return (
      <div data-selector={'acknowledge-box'}>
        <Text>{this.props.blurb}</Text>

        <Checkbox
          id={'acknowledge'}
          isChecked={this.state.isTicked}
          onChange={this.onChange}
          variant="outline"
          size="lg"
        >
          I understand
        </Checkbox>
      </div>
    );
  }
}

export default CheckBoxQuestion;
